import { Tracer, TraceMetadata, NullTracer, defaultTracer } from "./tracer";
import { TracerRegistry, getTracer, isTracingEnabled } from "./registry";

/**
 * Make a function traceable using the currently active tracer
 * 
 * @param fn The function to trace
 * @param metadata Metadata about the trace
 * @returns The traced function
 */
export function traceable<T extends (...args: any[]) => any>(
  fn: T,
  metadata: TraceMetadata
): T {
  // Only trace if tracing is enabled
  if (!isTracingEnabled()) {
    return fn;
  }

  // Get the active tracer and trace the function
  return getTracer().traceable(fn, metadata);
}

// Export everything from the tracer module
export { NullTracer, defaultTracer, TracerRegistry, getTracer, isTracingEnabled };
export type { Tracer, TraceMetadata }; 